<template>
  <div>
    <div class="text">
      <div class="textL" v-text="title"></div>
      <div class="textR" v-text="textR"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      textL: "",
      textR: "",
    };
  },
  props: ["title", "value"],
  watch: {
    value(newV, oldV) {
      this.textR = newV;
    },
  },
};
</script>

<style  scoped>
.text {
  display: flex;
  flex-direction: row;
}

.textL {
  width: 65px;
  text-align: left;
}
</style>
